/* Page to display the info for the Scene Page
    Breakdowns and Workspaces features */
import React from "react";
import { useHistory } from "react-router-dom";
import styles from "../../styles/Home.module.css";
import appStyles from "../../App.module.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import breakMo from "../../assets/breakMo.png";
import workBreak from "../../assets/workBreak.png";
import breakMoEdit from "../../assets/breakMoEdit.png";
import track1 from "../../assets/track1.png";
import workChars1 from "../../assets/workChars1.png";
import workDeps from "../../assets/workDeps.png";
import workDepsMo from "../../assets/workDepsMo.png";
import workPostMo from "../../assets/workPostMo.png";
import workPosts from "../../assets/workPosts.png";
import workPostsMo from "../../assets/workPostsMo.png";
import WorkS1 from "../../assets/WorkS1.png";
import workS1Mo from "../../assets/workS1Mo.png";
import work4 from "../../assets/work4.png";
import work7 from "../../assets/work7.png";
import btnStyles from "../../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";

const Workspaces = () => {
  const history = useHistory();
  
  return (
    <div className={`mt-0 ${styles.BlueBody} mx-0`}>
    <h2 className={`text-center py-2 ${styles.SubTitle } ${appStyles.cinzel}`}>
      SCENES WORKSPACE - BREAKDOWNS & WORKSHOPS</h2>
    <Row className="mt-1 ml-2" >
        <Col xs={3}>
        <Button
          className={`${btnStyles.Button} ${btnStyles.Blue} mb-2`}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
        </Col>
    </Row>
    {/* desktop */}
    <div className="d-none d-md-block">
    {/* one */}
    <Row className="mt-1 mt-md-3 pb-4 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }} className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The primary Creative work takes place in the the Scenes Workspace
    </h4>
    <h4 >
    The Scene page being the Platform's core Production element 
    </h4>
     <h4 >
    Create Scenes quickly then select a Scene to work in
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={WorkS1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 2 */}
    <Row className="mt-1 mt-md-3 pb-4 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8} className="text-center px-1 px-md-3" >
    <div className="text-center px-1 px-md-3 mb-3">
    <Image src={work7} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
    className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Each Scene contains a Breakdown, Workshop, Shotlist, Characters/BG,
    Storyboard, Moodboards and Script feature
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 3 */}
    <Row className="mt-1 mt-md-3 pb-4 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }} className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
     Create the Scene Breakdown quickly with the help of Select Dropdowns
    </h4>
    <h4 >
     This will be automatically loaded in other features, including Stripboards
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workBreak} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 4 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workChars1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
    className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
     Create the Scene Character/BG Breakdown, the Characters being added quickly from a Dropdown
    </h4>
    <h4 >The Wardrobe Department can use the Costume box to quickly add or update
     Character's Costumes Numbers which will also be automatically loaded in other features
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 5 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Use the Production Tracker to design, collaborate and build Production Items by Scene 
    in the Scene Workshops 
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
      <Image src={track1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 6 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workDeps} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
      The Workshops are divided by Department with Requirements, Workspaces 
    and Finals Categories, each displaying the number of Read and Unread Posts
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 7 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The Posts display in each Department's Category as read or unread
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workPosts} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 8 */}
    <Row className="mt-1 mt-md-3 pb-4 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8} className="text-center px-1 px-md-3" >
    <div className="text-center px-1 px-md-3 mb-3">
    <Image src={work4} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
    className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
      <h4 >
    Upload Ideas and Images/Files in Posts each with a Comments Section
    </h4>
    <h4 >
    On a separate page the Quick Find Posts page is used to easily find Posts by Department, your Feed 
    or Liked or Starred Posts
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* mobile view */}
    <div>
    {/* 1 Scenes */}
    <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={workS1Mo} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Scenes Workspace in Mobile View
    </h4>
    </div>
    </Col>
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={workDepsMo} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Scene Page and Workshop in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 2 Posts */}
    <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={workPostsMo} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Workshop Posts page in Mobile View
    </h4>
    </div>
    </Col>
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={workPostMo} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    A Workshop Post in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 3 breakdown */}
    <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={breakMo} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Scene Breakdown in Mobile View
    </h4>
    </div>
    </Col>
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={breakMoEdit} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Breakdown Edit page in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    </div>
    </div>
    {/* mobile */}
    <div className="d-block d-md-none">
    {/* one */}
    <Row className="mt-3 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12}>
    <div className="text-center px-1 px-md-3">
    <Image src={WorkS1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} className="text-center mt-5 px-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The primary Creative work takes place in the the Scenes Workspace
    </h4>
    <h4 >
    The Scene page being the Platform's core Production element 
    </h4>
    <h4 >
    Create Scenes quickly then select a Scene to work in
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 2 */}
    <Row className="mt-3 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8} className="text-center px-1 px-md-3" >
    <div className="text-center px-1 px-md-3 mb-3">
    <Image src={work7} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
    className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Each Scene contains a Breakdown, Workshop, Shotlist, Characters/BG,
    Storyboard, Moodboards and Script feature
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 3 */}
    <Row className="mt-3 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workBreak} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
     Create the Scene Breakdown quickly with the help of Select Dropdowns
    </h4>
    <h4 >
     This will be automatically loaded in other features, including Stripboards
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 4 */}
    <Row className="mt-3 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workChars1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
    className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
     <h4 >
     Create the Scene Character/BG Breakdown, the Characters being added quickly from a Dropdown
    </h4>
    <h4 >The Wardrobe Department can use the Costume box to quickly add or update
     Character's Costumes Numbers which will also be automatically loaded in other features
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 5 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
      <Image src={track1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Use the Production Tracker to design, collaborate and build Production Items by Scene 
    in the Scene Workshops
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 6 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workDeps} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
      The Workshops are divided by Department which use Requirements, Workspaces 
    and Finals Categories each displaying the number of Read and Unread Posts
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 7 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={workPosts} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The Posts display in each Department's Category as read or unread
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 8 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={work4} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
      <h4 >
    Upload Ideas and Images/Files in Posts each with a Comments Section
    </h4>
    <h4 >
    On a separate page the Quick Find Posts page is used to easily find Posts by Department, your Feed 
    or Liked or Starred Posts
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    <div>
      {/* 1 Scenes */}
      <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={workS1Mo} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      The Scenes Workspace in Mobile View
      </h4>
      </div>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      </Col>
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={workS1Mo} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      The Scene Page and Workshop in Mobile View
      </h4>
      </div>
      </Col>
      </Row>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      {/* 2 Posts */}
      <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={workPostsMo} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      The Workshop Posts page in Mobile View
      </h4>
      </div>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      </Col>
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={workPostMo} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      A Workshop Post in Mobile View
      </h4>
      </div>
      </Col>
      </Row>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      {/* 3 breakdown */}
      <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={breakMo} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      The Scene Breakdown in Mobile View
      </h4>
      </div>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      </Col>
      <Col xs={12} md={6}>
      <div className="text-center px-1 px-md-3">
      <Image src={breakMoEdit} alt="image" 
        className={` ${styles.FeatureImage}`} />
      </div>
      <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
      <h4 >
      The Breakdown Edit page in Mobile View
      </h4>
      </div>
      </Col>
      </Row>
      <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
      <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
      </hr>
      </div>
      </div>
    </div>
    </div>
  )
}

export default Workspaces